import styled from 'styled-components'

export const Page = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #ffffff;
  border-radius: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  width: 595px;
  margin: 0 24px;
  padding: 2rem 2rem;
  font-size: 12px;

  @media (max-width: 665px) {
    zoom: 0.5;
    font-size: 11px;
    -webkit-text-size-adjust: 50%;
  }

  @media (max-width: 335px) {
    zoom: 0.4;
    font-size: 10.5px;
  }

  & > div {
    width: 100%;
  }
`

export const Document = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 2rem 0;
`

export const LoadingContainer = styled.div`
  margin-top: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ArrowArea = styled.div`
  display: flex;
  width: 40rem;
  padding: 24px;

  @media (max-width: 665px) {
    padding: 12px;
    zoom: 0.5;
    font-size: 11px;
    -webkit-text-size-adjust: 50%;
  }

  @media (max-width: 335px) {
    zoom: 0.4;
    font-size: 10.5px;
  }
`
